export default __webpack_public_path__ + "media/images/burger-7572e0a2a536f789e77d6da949d61cc9.svg";